import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';

// Components
import Anime from '../../components/Anime/Anime';

// Containers
import ContentHeader from '../../containers/ContentHeader/ContentHeader';
import Themes from '../../containers/Themes/Themes';
import Hero from '../../containers/Hero/Hero';
import HeroLayer from '../../containers/Hero/HeroLayer';

class PageThemes extends Component {

    render () {

        return (
            <div className="app-section mb-md">
                    <MetaTags>
                        <title>Creative WordPress Themes</title>
                        <meta name="description" content="Creative WordPress themes for creative artists." />
                    </MetaTags>

                <Hero height="auto" classes="hero-page">
                	<div className="container">
		            	<ContentHeader title="Creative WordPress Themes" subTitle="Browse through our themes to find the perfect one for your needs." classes="" />
	                </div>
		            <HeroLayer
	                	classes="lines-bg anim anim--fade anim--duration-4 anim--delay-3"
	                	styleOuter={{
	                		zIndex:1
	                	}}
	                	styleInner={{
	                		top: 0,
	                		bottom: 0,
	                		left:0,
	                		right:0,
	                		opacity:0.6,
                    		backgroundSize: "cover",
	                		backgroundImage: "url(https://rascalsthemes.com/images/dark-texture.jpg)",
	                	}}
	                />
            	</Hero>

                <div className="container">
                    <Anime type="fade-up" delay="3" duration="3">
                    	<Themes title="" limit="-1" grid="col-12 col-md-4 mb2 mb2-lg mb2-md" classes="mb mb-md" />
                    </Anime>
                </div>
            </div>
        );
    }
}

export default PageThemes;


// WEBPACK FOOTER //
// ./src/pages/PageThemes/PageThemes.js